import http from "../http-common";


const getDatacenters = () => {
  return http.get("/get-datacenters");
};
const DataCenterService = {
    getDatacenters,
}
export default DataCenterService;